import React from 'react'
import Banner from './Banner'
import Video from './Video'
import Review from './Review'
import Plan from './Plan'
import Bonus from './Bonus'
import Brainer from './Brainer'
import Helpbot from './Helpbot'
import ServiceTech from './ServiceTech'
import StepPart from './StepPart'

const TenDaysFreeTrialNew = () => {
  return (
    <>
     
     <Banner/>
     <ServiceTech/>
     <StepPart/>
     <Video/>
     <Review/>
     <Plan/>
     <Bonus/>
     <Brainer/>
     <Helpbot/>
    </>
  )
}

export default TenDaysFreeTrialNew